/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import text from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import BooleanField from 'ContentComponents/cmv2/fields/Boolean';
import ToolFormControl from 'DesignComponents/tool/ToolFormControl';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import DisplayTypes from 'ContentUtils/constants/CustomWidgetFieldDisplayTypes';
import { BOOLEAN } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { DEFAULT, DISPLAY } from 'DesignData/enums/CustomWidgetFieldAttributes';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

export default class _class extends Component {
  constructor(...args) {
    super(...args);

    this.onDefaultChange = value => {
      this.props.editField({
        [DEFAULT]: value
      });
    };

    this.onDisplayChange = e => {
      this.props.editField({
        [DISPLAY]: e.target.name
      });
    };
  }

  renderDisplayOptions() {
    const {
      field
    } = this.props;
    const radios = Object.values(DisplayTypes[BOOLEAN]).map(displayType => {
      const checked = field[DISPLAY] === displayType;
      return /*#__PURE__*/_jsx(UIRadioInput, {
        checked: checked,
        inline: true,
        name: displayType,
        onChange: this.onDisplayChange,
        size: "small",
        className: "content-options-radio-input",
        children: text(i18nKey(`display.displayTypeLabels.${displayType}`))
      }, displayType);
    });
    return /*#__PURE__*/_jsx(ToolFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('display.label')
      }),
      children: /*#__PURE__*/_jsx(Fragment, {
        children: radios
      })
    });
  }

  render() {
    const {
      field,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [this.renderDisplayOptions(), /*#__PURE__*/_jsx(ToolFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`${BOOLEAN}.label`)
        }),
        children: /*#__PURE__*/_jsx(SidebarInput, {
          className: "dm-boolean-field",
          display: field[DISPLAY],
          inputComponent: BooleanField,
          label: text(i18nKey(`defaultLabels.${BOOLEAN}`)),
          onFieldChange: this.onDefaultChange,
          readOnly: readOnly,
          value: field[DEFAULT]
        })
      })]
    });
  }

}
_class.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  readOnly: PropTypes.bool
};